<template>
  <div class="top">
    <Header />
    <Hero />
  </div>
</template>

<script>
import Hero from './Hero.vue';
import Header from './Header.vue';

export default {
  name: 'Top',
  components: {
    Hero,
    Header,
  },
};
</script>

<style lang="scss" scoped>
/* breakpoints */
$desktop-media: 75em;

.top {
  padding-top: var(--sm-spacer);
  border-radius: 0 0 0 var(--fs-h0);
  color: var(--white);

  background: no-repeat url(../../../assets/blogr/bg-pattern-intro.svg),
              linear-gradient(to right, var(--g-very-light-red), var(--g-light-red));
  background-position: center;

  @media (min-width: $desktop-media) {
    background: url(../../../assets/blogr/bg-pattern-intro.svg),
                linear-gradient(to right, var(--g-very-light-red), var(--g-light-red));
    background-position: left;
  }
}
</style>
